import App from 'app/app.js';
import '@app/components/package-customize/premium-bg/premium-bg-info-label.js';
import template from './customize-preview.html';
import './customize-preview.scss';

class CustomizePreviewController {
  position = 1;
  amount = 1;
  applyToAllMobile = false;

  constructor($scope, $compile, $element, $timeout, $filter, $templateCache, CustomizationImageService) {
    this.$scope = $scope;
    this.$compile = $compile;
    this.$element = $element;
    this.$filter = $filter;
    this.customizationImageService = CustomizationImageService;
    this.$timeout = $timeout;
  }

  $onChanges(changes) {
    if (changes.look || changes.bearerTokenUrl) {
      this.lookWithBearerTokenUrl = this.look ? { ...this.look, bearerTokenURL: this.bearerTokenUrl } : null;
    }
  }

  getCountText() {
    if (!this.look) return '';
    if (this.look.previewImageNon) {
      return this.getTranslation('ADDON_ZOOM_DISCLAIMER');
    }

    return this.getTranslation('SHEET_POSITION', {
      position: this.position,
      amount: this.amount
    });
  }

  isPremiumBackground() {
    return Boolean(this.look?.background?.premiumUpgrade);
  }

  isPremiumBackgroundIncluded() {
    return (
      this.isPremiumBackground() &&
      this.customizationImageService.isPremiumBgIncludedForItem(
        this.customizationImageService.getSelectedOrderLineDetailIndex(true),
        this.look.background
      )
    );
  }

  applyAll() {
    this.applyToAll({ applyToAllMobile: this.applyToAllMobile });
  }

  getTranslation(key, params) {
    return this.$filter('ltTranslateFilter')(key, params);
  }

  setOrientation() {
    const img = this.$element[0].querySelector('img');
    if (!img) return;
    if (img.complete && img.naturalWidth) {
      this.applyOrientation(img);
    } else {
      img.onload = () => {
        this.applyOrientation(img);
      };
    }
  }
  getOrientationClass(width, height) {
    if (!width || !height) return '';
    return height >= width ? 'portrait' : 'landscape';
  }
  applyOrientation(img) {
    this.$scope.$applyAsync(() => {
      this.imageOrientationClass = this.getOrientationClass(img.naturalWidth, img.naturalHeight);
    });
  }
  $onInit() {
    this.$scope.$watch(
      () => this.look?.layoutThemeID,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.$timeout(() => {
            this.setOrientation();
          });
        }
      }
    );
  }
}
CustomizePreviewController.$inject = [
  '$scope',
  '$compile',
  '$element',
  '$timeout',
  '$filter',
  '$templateCache',
  'CustomizationImageService'
];

App.component('ltCustomizePreview', {
  template,
  bindings: {
    look: '<',
    bearerTokenUrl: '<',
    item: '<',
    amount: '<',
    position: '<',
    applyToAll: '&',
    applyToAllDisabled: '<',
    onPrevSheet: '&',
    prevDisabled: '<',
    onNextSheet: '&',
    nextDisabled: '<'
  },
  controller: CustomizePreviewController,
  controllerAs: 'preview'
});
